import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";

const useShouldShowDefaultInquiry = () => {
  const { contextInquiryText } = useMemberToobarContext();

  return Boolean(contextInquiryText);
};

export { useShouldShowDefaultInquiry };
